<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="500px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <span class="edit-button" slot="activator">edit</span>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="valid">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Edit Payment &amp; Terms</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <span class="done-button" @click="onSaveChanges" v-if='valid'>done</span>
            <span class="done-button disabled" v-if='!valid'>done</span>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex >
            <v-textarea
            name="paymentTerms"
            label="Payment terms &amp; instructions"
            id="paymentTerms"
            v-model="addedpaymentTerms"
            placeholder=" "
            autofocus
            ref="focus"
            required></v-textarea>
          </v-flex>
          <v-flex>
            <v-checkbox
              label="Save as the default for all future invoices and quotes"
              v-model="saveAsDefault"
              ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'

export default {
  name: 'EditPaymentDetailsModal',
  props: {
    invoice: Object
  },
  data () {
    return {
      valid: false,
      showDialog: false,
      saveAsDefault: true,
      addedpaymentTerms: this.invoice.paymentTerms,
      groupId: this.$store.getters.user.group
    }
  },
  watch: {
    showDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    onSaveChanges () {
      // quick check to ensure the title is here
      if (this.addedpaymentTerms.trim() === '') {
        return
      }
      // return these details to the invocie component
      this.$emit('return-payment-details', {
        paymentTerms: this.addedpaymentTerms
      })
      // If we are setting these as default save them to FB which will push them to the store for us.
      if (this.saveAsDefault === true) {
        // Make the update object
        const groupUpdate = {
          paymentTerms: this.addedpaymentTerms
        }
        // save object to FB
        firebase.database().ref('groups').child(this.groupId).update(groupUpdate)
          .then(() => {
            this.$store.commit('setLoading', false)
          })
          .catch(error => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          })
      }
      this.showDialog = false
    },
    toggleDialog () {
      this.showDialog = !this.showDialog
    }
  }

}
</script>
